export default __webpack_public_path__ + "static/accents-color-accessibility-2-light-91b3aba57c00d8aabf762fb8a85c79dc49fdc85e78daf0850b9bec01bc69f54c.png";